"use client"

import { FaqAccordion } from "@shared/ui/landing/faq-accordion"
import { SectionContainer } from "@shared/ui/landing/section-container"

import { faqIds } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

export function FaqSection() {
  const t = useTranslations("faq")

  const items = faqIds.map((id) => ({
    question: t(`${id}.question`),
    answer: t(`${id}.answer`),
  }))

  return (
    <SectionContainer id="faq">
      <div className="mx-auto max-w-2xl">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-brand">{t("title")}</h2>
          <p className="mt-3 text-muted-foreground">{t("subtitle")}</p>
        </div>

        <div className="mt-10 [&_.overflow-hidden]:border-brand [&_.overflow-hidden]:bg-white">
          <FaqAccordion items={items} />
        </div>
      </div>
    </SectionContainer>
  )
}
